export default "__VITE_ASSET__4ffa60af__"